var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sso-callback"},[_vm._v(" 로그인 처리 중... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }